export default __webpack_public_path__ + "static/media/netvrk-v2-1.1b248019.jpg";